import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import i18n from '../../../internationalization/i18n';

const propTypes = {
  filterValue: PropTypes.object,
  categories: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

const defaultProps = {
  filterValue: null,
};

const BaseModuleCategoryFilter = ({ filterValue, categories, onSelect }) => (
  <div className="c-bb-select">
    <Select
      value={filterValue}
      onChange={onSelect}
      clearable
      placeholder={i18n.t('BASE_MODULE.allCategories').toUpperCase()}
      options={categories.map((ctg) => {
        const ctgclone = { ...ctg };
        const parent = (typeof ctg.parent !== 'undefined' ? `${ctg.parent}: ` : '');
        ctgclone.title = `${parent}${ctg.title}`;
        return ctgclone;
      })}
      valueKey="id"
      labelKey="title"
    />
  </div>
);

export default BaseModuleCategoryFilter;

BaseModuleCategoryFilter.propTypes = propTypes;
BaseModuleCategoryFilter.defaultProps = defaultProps;




// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleCategoryFilter.js